module.exports = __webpack_public_path__ + "static/network1-7b8f9f0ecc26a9113757323658399239.png";